import React from 'react';
import { Typography, InputNumber } from 'antd';
import { CustomTooltip } from './custom-tooltip';
import { useResponsiveSizes } from '../../../hooks/use-responsive-sizes';
import type { BaseFieldProps } from '../../../types/form-renderer';
import type { NumberField as NumberFieldType } from '../../../types/templates';

const { Text } = Typography;

type Props = BaseFieldProps<NumberFieldType> & { onBlur?: () => void };

export const NumberField: React.FC<Props> = ({ field, value, onChange, onBlur, commonStyle, labelStyle, error }) => {
  const { fontSize } = useResponsiveSizes();

  return (
    <div style={commonStyle}>
      <Text type='secondary' style={{ ...labelStyle, textTransform: 'uppercase' }}>
        {field.label}
      </Text>
      <CustomTooltip field={field}>
        <InputNumber
          placeholder={field.placeholder}
          style={{ fontSize: fontSize.base, width: '100%' }}
          value={value}
          onChange={val => onChange(val ?? 0)}
          onBlur={onBlur}
          status={error ? 'error' : undefined}
          min={1}
          precision={0}
          controls
        />
      </CustomTooltip>
      {error && (
        <Text type='danger' style={{ fontSize: fontSize.sm, marginTop: 4 }}>
          {error}
        </Text>
      )}
    </div>
  );
};
